export const SliderData = [
  {
    "id": 1,
    "name": "The Best Quality Products Guaranteed!",
    "description": "",
    "img": "/assets/Banner/banner1.jpeg"
},
{
    "id": 2,
    "name": "Best Different Type of Grocery Store",
    "description": "",
    "img": "/assets/Banner/banner2.jpeg"
},
{
    "id": 3,
    "name": "Quality Freshness Guaranteed!",
    "description": "",
    "img": "/assets/Banner/banner3.jpeg"
}
  ];